import React from "react";
import Toast from "./Toast";
import { ToastType } from "./ToastContext";
import "./Toast.css";

interface ToastItem {
    id: number;
    message: string;
    type: ToastType;
    duration: number;
}

interface Props {
    toasts: ToastItem[];
    removeToast: (id: number) => void;
}

const ToastManager: React.FC<Props> = ({ toasts, removeToast }) => {
    return (
        <div className="toast-container">
            {toasts.map((toast) => (
                <Toast
                    key={toast.id}
                    {...toast}
                    onClose={() => removeToast(toast.id)}
                />
            ))}
        </div>
    );
};

export default ToastManager;
